// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"156":"8f4858e7","354":"7b8c0bb5"}[chunkId] + ".chunk.css";
};